export default __webpack_public_path__ + "static/media/vss.d80f028a.svg";